import React from 'react';
import { styled } from '@linaria/react';
import { AnimatePresence, motion } from 'framer-motion';
export type AnimatedLayerPosition = 'sticky' | 'absolute';
const _exp = /*#__PURE__*/() => motion.div;
const AnimatedLayer = /*#__PURE__*/styled(_exp())({
  name: "AnimatedLayer",
  class: "ahkbln0",
  propsAsIs: true
});
type Props = {
  isFooterVisible: boolean;
  position?: AnimatedLayerPosition;
};

// The height is an approximation, it's best to overestimate so we start slightly under the screen
const FOOTER_HEIGHT = 100;
export const Footer: React.FC<Props> = ({
  children,
  isFooterVisible,
  position = 'sticky'
}) => {
  return <AnimatePresence>
      {isFooterVisible && <AnimatedLayer style={{
      position
    }} key="ap-bottom-cta" initial={{
      y: FOOTER_HEIGHT
    }} animate={{
      y: 0
    }} exit={{
      y: FOOTER_HEIGHT
    }} transition={{
      duration: 0.5
    }}>
          {children}
        </AnimatedLayer>}
    </AnimatePresence>;
};

require("./Footer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Footer.tsx");